import React, { ReactNode, useEffect, useRef } from 'react';

const SwipeBlocker = ({ children }: { children: ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const blockSwipe = (e: TouchEvent) => {
      e.stopPropagation(); // Prevent touch events from passing through SwipeableViews
    };

    el.addEventListener('touchstart', blockSwipe, { passive: false });
    el.addEventListener('touchmove', blockSwipe, { passive: false });

    return () => {
      el.removeEventListener('touchstart', blockSwipe);
      el.removeEventListener('touchmove', blockSwipe);
    };
  }, []);

  return (
    <div ref={ref} style={{ overflowX: 'auto' }}>
      {children}
    </div>
  );
};

export default SwipeBlocker;
